<template>
  <div class="editor">
    <CloseButton @close="$emit('call-editor', 'close')" />
    <div class="-header">
      <div class="--title">
        <span>Create Course Outline</span>
      </div>
      <span class="--subtitle">สร้าง Course Outline</span>
    </div>

    <div class="-body">
      <Block no-border>
        <SelectBox
          label="เลือกระดับชั้น"
          :options="degreeOptions"
          :prop="{ target: 'id', transform: 'degreeId' }"
          @input="inputHandler"
        />
      </Block>

      <Block no-border>
        <SelectBox
          label="เลือกกลุ่มวิชา"
          :options="subjectGroupOptions"
          :prop="{ target: 'id', transform: 'subjectGroupId' }"
          @input="inputHandler"
        />
      </Block>

      <Block no-border>
        <SelectBox
          label="เลือกชื่อวิชา"
          :options="subjectOptions"
          :prop="[
            { target: 'id', transform: 'subjectId' },
            { target: 'code', transform: 'subjectCode' }
          ]"
          @input="inputHandler"
        />
      </Block>

      <Block no-border>
        <SelectBox
          label="เลือกผู้สอน"
          :options="teacherOptions"
          :prop="[
            { target: 'id', transform: 'teacherId' },
            { target: 'code', transform: 'teacherCode' }
          ]"
          @input="inputHandler"
        />
      </Block>

      <div class="--controllers">
        <vs-button
          @click="createNewCourseOutline"
          :disabled="!isReadyToCreate"
        >
          Create
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import Block from "@/components/common-ui/block/index.vue";
import SelectBox from "@/components/common-ui/forms/select-box/index.vue";
import { getSubjectsBySubjectGroup } from "@/services/api/common-data";
import { getTeachers } from "@/services/api/personal-profile/teacher";
import { addCourseOutline } from "@/services/api/course-outline";

export default {
  props: {
    mode: String,
    edata: Object,
  },
  components: {
    CloseButton: () => import("./editor-close"),
    Block,
    SelectBox
  },
  data() {
    return {
      selection: {},
      subjectOptions: [{ id: "", title: "" }],
      teacherOptions: [{ id: "", title: "" }]
    }
  },
  computed: {
    isReadyToCreate() {
      const inputFields = Object.keys(this.selection);
      const checkFields = inputFields.every(field => field !== "" && field !== null);
      if (checkFields && inputFields.length >= 6) {
        return true;
      }
      return false;
    },
    degreeOptions() {
      return this.transformDegreeOptions(this.$store.state.MasterData.degrees)
    },
    subjectGroupOptions() {
      return this.transformSubjectGroupOptions(this.$store.state.MasterData.subjectGroups)
    },
  },
  watch: {
    async 'selection.subjectGroupId'(subjectGroupId) {
      if (subjectGroupId) {
        const data = await this.getSubjectOptions(subjectGroupId);
        this.subjectOptions = data;
        delete this.selection.subject;
      }
    }
  },
  methods: {
    async getSubjectOptions(subjectGroupId) {
      if (subjectGroupId) {
        if (Object.prototype.hasOwnProperty.call(this.selection, 'subjectGroupId')) {
          const subjectGroupId = this.selection.subjectGroupId;
          return await getSubjectsBySubjectGroup(subjectGroupId);
        }
      }
    },
    async getTeacherOptions() {
      return await getTeachers();
    },
    transformDegreeOptions(list) {
      if (list && Array.isArray(list)) {
        return list.map(item => {
          return { id: item.id, title: item.nameLocal, code: item.code };
        })
      }
      return [{ id: "", title: "No degree options"}];
    },
    transformSubjectGroupOptions(list) {
      if (list && Array.isArray(list)) {
        return list.map(item => {
          return { id: item.id, title: item.nameLocal, code: item.code };
        })
      }
      return [{ id: "", title: "No subject group options"}];
    },
    transformTeacherOptions(list) {
      if (list && Array.isArray(list)) {
        return list.map(item => {
          return {
            id: item.id,
            title: 'อาจารย์ ' + item.firstNameLocal + ' ' + item.lastNameLocal,
            code: item.code
          };
        })
      }
    },
    async loadData() {
      this.teacherOptions = this.transformTeacherOptions(
        await this.getTeacherOptions()
      );
    },
    onSubjectGroupsSelectChanged(val) {
      if (val) {
        const { selection } = val;
        if (selection) {
          this.updateSubjectOptions(selection);
        }
      }
      // if (this.selection.subjectGroup) {
      //   this.updateSubjectOptions(this.selection.subjectGroup);
      // } else {
      // }
    },
    updateSubjectOptions(subjectGroupId) {
      this.getSubjectOptions(subjectGroupId)
    },
    async createNewCourseOutline() {
      const newCourseOutline = {
        degreeId: this.selection['degreeId'] || null,
        subjectGroupId: this.selection['subjectGroupId'] || null,
        subjectId: this.selection['subjectId'] || null,
        subjectCode: this.selection['subjectCode'] || null,
        teacherId: this.selection['teacherId'] || null,
        teacherCode: this.selection['teacherCode'] || null
      };

      const res = await addCourseOutline(newCourseOutline);
      if (res) {
        this.$emit("call-editor", "close");
        this.$router.push({
          name: "course-outline"
        })
      }
    },
    inputHandler(val) {
      const { prop, data } = val;
      if (Object.prototype.hasOwnProperty.call(val, 'multipleValues')) {
        Object.keys(val.multipleValues).map(prop => {
          this.$set(this.selection, prop, val.multipleValues[prop] );
        })
      } else {
        this.$set(this.selection, prop, data);
      }
      this.$forceUpdate();
    },
  },
  async created() {
    await this.loadData();

    if (this.mode === "edit") {
      this.newAssessment = this.edata;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common-scoped";

.editor {
  display: flex;
  flex-direction: column;

  & .-header {
    width: 100%;
    display: block;
    margin-bottom: 20px;

    & .--title {
      font-size: 2rem;
      color: #6f66b9;
      padding-bottom: 1rem;
      width: 100%;
      height: 3rem;
      border-bottom: 2px solid #e8e8e8;
    }
    & .--subtitle {
      margin-top: 1rem;
      font-size: 1rem;
    }
  }

  & .-body {
    display: flex;
    width: 80%;
    flex-direction: column;

    & .--controllers {
      margin-top: 20px;
    }
  }
}
</style>
